// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--action-authorize.json";
import part1 from "./en/src--csat.json";
import part2 from "./en/src--customization.json";
import part3 from "./en/src--list.json";
import part4 from "./en/src--login.json";
import part5 from "./en/src--portal-four--oms.json";
import part6 from "./en/src--portal-four--orders--gift-receipts--create-gift-receipt--choose-recipient.json";
import part7 from "./en/src--portal-four--orders--gift-receipts--create-gift-receipt--dispatcher.json";
import part8 from "./en/src--portal-four--orders--gift-receipts--create-gift-receipt--select-items.json";
import part9 from "./en/src--portal-four--orders--gift-receipts--details--share.json";
import part10 from "./en/src--portal-four--orders--gift-receipts--details.json";
import part11 from "./en/src--portal-four--orders--gift-receipts--manage.json";
import part12 from "./en/src--portal-four--orders--gift-receipts.json";
import part13 from "./en/src--portal-four--orders--hooks.json";
import part14 from "./en/src--portal-four--orders--hsa-reimburse--screens.json";
import part15 from "./en/src--portal-four--orders--hsa-reimburse.json";
import part16 from "./en/src--portal-four--orders--return-method.json";
import part17 from "./en/src--portal-four--orders.json";
import part18 from "./en/src--portal-four--register--components.json";
import part19 from "./en/src--portal-four--register--hooks.json";
import part20 from "./en/src--portal-four--register--screens.json";
import part21 from "./en/src--portal-four--register.json";
import part22 from "./en/src--portal-four--returns--additional-claim-documents.json";
import part23 from "./en/src--portal-four--returns--components--dropoffs.json";
import part24 from "./en/src--portal-four--returns--components.json";
import part25 from "./en/src--portal-four--returns--confirmation-display.json";
import part26 from "./en/src--portal-four--returns--exchange-conversion.json";
import part27 from "./en/src--portal-four--returns.json";
import part28 from "./en/src--portal-four--shared-components.json";
import part29 from "./en/src--portal-four--submission--components--cart.json";
import part30 from "./en/src--portal-four--submission--components--flow--exchange-agent.json";
import part31 from "./en/src--portal-four--submission--components--product-configurator--media.json";
import part32 from "./en/src--portal-four--submission--components--product-configurator--product-options.json";
import part33 from "./en/src--portal-four--submission--components--product-configurator.json";
import part34 from "./en/src--portal-four--submission--components--shop-now-bonus-exchange-agent-card.json";
import part35 from "./en/src--portal-four--submission--components--variant-picker.json";
import part36 from "./en/src--portal-four--submission--components.json";
import part37 from "./en/src--portal-four--submission--hooks.json";
import part38 from "./en/src--portal-four--submission--screens--cart.json";
import part39 from "./en/src--portal-four--submission--screens--choose-compensation-method--add-exchange-item.json";
import part40 from "./en/src--portal-four--submission--screens--choose-compensation-method.json";
import part41 from "./en/src--portal-four--submission--screens--claim-documents-return.json";
import part42 from "./en/src--portal-four--submission--screens--flow-return.json";
import part43 from "./en/src--portal-four--submission--screens--item-details.json";
import part44 from "./en/src--portal-four--submission--screens--login.json";
import part45 from "./en/src--portal-four--submission--screens--merchant-flow.json";
import part46 from "./en/src--portal-four--submission--screens--package-pickup.json";
import part47 from "./en/src--portal-four--submission--screens--review--merchant-overrides.json";
import part48 from "./en/src--portal-four--submission--screens--review.json";
import part49 from "./en/src--portal-four--submission--screens--select-items.json";
import part50 from "./en/src--portal-four--submission--screens--shipment-method.json";
import part51 from "./en/src--portal-four--submission--screens--shop-now.json";
import part52 from "./en/src--portal-four--submission--screens--withdrawal-review.json";
import part53 from "./en/src--portal-four--submission.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
  part9,
  part10,
  part11,
  part12,
  part13,
  part14,
  part15,
  part16,
  part17,
  part18,
  part19,
  part20,
  part21,
  part22,
  part23,
  part24,
  part25,
  part26,
  part27,
  part28,
  part29,
  part30,
  part31,
  part32,
  part33,
  part34,
  part35,
  part36,
  part37,
  part38,
  part39,
  part40,
  part41,
  part42,
  part43,
  part44,
  part45,
  part46,
  part47,
  part48,
  part49,
  part50,
  part51,
  part52,
  part53,
);
